module.exports = __webpack_public_path__ + "img/del.0d7f14f3.svg";